export default "__VITE_ASSET__a2e33f13__"